import { Controller } from "@hotwired/stimulus"

// Controller for the OTP verification modal in the signing flow
export default class extends Controller {
  static targets = ["modal", "otpForm", "otpSubmit"]

  connect() {
    // Store bound function for cleanup
    this.boundFocusFirstInput = this.focusFirstInput.bind(this)
  }

  openAndSendOtp(event) {
    event.preventDefault()

    // Open the modal
    if (this.hasModalTarget) {
      this.modalTarget.classList.remove('hidden')
      document.body.classList.add('overflow-hidden')
    }

    // Submit the hidden OTP form to send the code
    if (this.hasOtpSubmitTarget) {
      this.otpSubmitTarget.click()
    }

    // Focus first OTP input after a short delay
    setTimeout(this.boundFocusFirstInput, 300)
  }

  open(event) {
    event.preventDefault()
    if (this.hasModalTarget) {
      this.modalTarget.classList.remove('hidden')
      document.body.classList.add('overflow-hidden')
    }
  }

  close(event) {
    if (event) event.preventDefault()
    if (this.hasModalTarget) {
      this.modalTarget.classList.add('hidden')
      document.body.classList.remove('overflow-hidden')
    }
  }

  focusFirstInput() {
    const firstInput = this.element.querySelector('input[type="text"]')
    if (firstInput) {
      firstInput.focus()
    }
  }
}
